import { UserDto } from '@app/generated/model';
import { Action } from '@ngrx/store';
import { User } from '@admin/models/user';
import { UserDetails } from '@admin/models/user-details';

export enum UserActionTypes {
  CurrentUserLoad = 'User Load',
  CurrentUserLoadSuccess = 'User Load Success',
  LoadAllUsers = '[Users] Load Users',
  LoadAllUsersSuccess = '[Users] Load Users Success',
  AddUser = '[Users] Add User',
  UpdateUser = '[Users] Update User',
  LoadUserDetails = '[Users] Load User Details',
  LoadUserDetailsSuccess = '[Users] Load User Details Success',
  SaveUser = '[Users] Save User]',
  FilterUsers = '[Users] Filter Users',
}

export class CurrentUserLoad implements Action {
  readonly type = UserActionTypes.CurrentUserLoad;
  constructor() {}
}

export class CurrentUserLoadSuccess implements Action {
  readonly type = UserActionTypes.CurrentUserLoadSuccess;

  constructor(public currentUser: UserDto) {}
}

export class LoadAllUsers implements Action {
  readonly type = UserActionTypes.LoadAllUsers;
  constructor() {}
}

export class LoadAllUsersSuccess implements Action {
  readonly type = UserActionTypes.LoadAllUsersSuccess;
  constructor(public allUsers: User[]) {}
}

export class AddUser implements Action {
  readonly type = UserActionTypes.AddUser;
  constructor(public user: User) {}
}

export class UpdateUser implements Action {
  readonly type = UserActionTypes.UpdateUser;
  constructor(public user: User) {}
}

export class LoadUserDetails implements Action {
  readonly type = UserActionTypes.LoadUserDetails;
  constructor(public username: string) {}
}

export class LoadUserDetailsSuccess implements Action {
  readonly type = UserActionTypes.LoadUserDetailsSuccess;
  constructor(public userDetail: UserDetails) {}
}

export class SaveUser implements Action {
  readonly type = UserActionTypes.SaveUser;
  constructor(public user: UserDetails) {}
}

export class FilterUsers implements Action {
  readonly type = UserActionTypes.FilterUsers;
  constructor(public filter: string) {}
}

export type UserActions =
  | CurrentUserLoad
  | CurrentUserLoadSuccess
  | LoadAllUsers
  | LoadAllUsersSuccess
  | AddUser
  | UpdateUser
  | LoadUserDetails
  | LoadUserDetailsSuccess
  | SaveUser
  | FilterUsers;
